export const getTestId = (props: object) => {
  if ("data-testid" in props && typeof props["data-testid"] === "string") {
    return props["data-testid"];
  }
  return undefined;
};
